import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DmsRoutingModule } from './dms-routing.module';
import { SharedModule } from '../shared/shared.module';
import { FilesComponent } from './files/files.component';
import { DocListComponent } from './doclist/doclist.component';
import { ConfirmDeleteComponent } from './confirm-delete/confirm-delete.component';
import { ConfirmRestoreComponent } from './confirm-restore/confirm-restore.component';
import { ConfirmPermanentDeleteComponent } from './confirm-permanent-delete/confirm-permanent-delete.component';
import { DownloadFolderComponent } from './download-folder/download-folder.component';
import { MoveDialogComponent } from './move/move.component';
import { CreateFolderComponent } from './create-folder/create-folder.component';
import { CreateGoogleDriveComponent } from './google-drive/create-google-drive.component';
import { WaitForImportComponent } from './google-drive/wait-for-import.component';
import { CreateOneDriveComponent } from './onedrive/create-onedrive.component';
import { CallbackComponent } from './onedrive/callback.component';
import { OneDrive } from './onedrive/onedrive.service';
import { UploadFilesComponent } from './upload-files/upload-files.component';
import { UploadService } from './upload.service';
import { SharingComponent } from './sharing/sharing.component';
import { ShareToEmailComponent } from './share-to-email/share-to-email.component';
import { VersionHistoryComponent } from './version-history/version-history.component';
import { RevertVersionComponent } from './revert-version/revert-version.component';
import { FoldersComponent } from './folders/folders.component';
import { SearchComponent } from './search/search.component';
import { ViewerComponent } from './viewer/viewer.component';
import { ViewShareComponent } from './view-share/view-share.component';
import { DeleteCommentComponent } from './delete-comment/delete-comment.component';
import { TrashComponent } from './trash/trash.component';
import { CorporateComponent } from './corporate/corporate.component';
import { CorporateMemberComponent } from './corporate-member/member.component';
import { SettingEtaxComponent } from './corporate-setting/setting.component';
import { TaxReportComponent } from './report/tax-report.component';
import { MonthlySummaryComponent } from './report-monthly/monthly.component';
import { CorporatePermissionComponent } from './corporate-permission/permission.component';
import { DocTypeComponent } from '../shared/doctype.component';
import { DownloadZipComponent } from './download-zip/download-zip.component';
import { SharedWithMeComponent } from './share-with-me/share-with-me.component';
import { SharedByMeComponent } from './share-by-me/share-by-me.component';
import { SharedLinkComponent } from './share-link/share-link.component';
import { FileUploader } from './file-uploader';
import { UploadProgressComponent } from './upload-progress/upload-progress.component';
import { DmsMenuComponent } from './dms-menu/dms-menu.component';
import { DmsSearchBoxComponent } from './search-box/search-box.component';
import { AnnotationControllerComponent } from './annotation-controller/annotation-controller.component';
import { EtaxSharedComponent } from './etax-shared/etax-shared.component';
import { InvoiceViewerComponent } from './etax-shared/invoice-viewer/invoice-viewer.component';
import { PoweredByComponent } from './etax-shared/powered-by/powered-by.component';
import { GoogleDrivePageComponent } from './google-drive-page/google-drive-page.component';
import { GoogleDriveListComponent } from './google-drive-list/google-drive-list.component';
import { GoogleDriveViewerComponent } from './google-drive-viewer/google-drive-viewer.component';
import { ViewSharePublicComponent } from './view-share-public/view-share-public.component';
import { ShareListComponent } from './view-share-public/sharelist/sharelist.component';
import { ShareViewerComponent } from './view-share-public/share-viewer/share-viewer.component';
import { ShareDownloadZipComponent } from './view-share-public/share-download-zip/share-download-zip.component';
import { ShareDownloadFolderComponent } from './view-share-public/share-download-folder/share-download-folder.component';
import { DownloadListComponent } from './annotation-controller/download-list/download-list.component';
import { UploadNewVersionComponent } from './annotation-controller/upload-new-version/upload-new-version.component';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import { InsertMergeFilesComponent } from './annotation-controller/insert-merge-files/insert-merge-files.component';
import { AnnotationControllerService } from './annotation-controller/annotation-controller.service';
import { GoogleDriveFoldersComponent } from './google-drive-folders/google-drive-folders.component';
import { CallbackDropboxComponent } from './dropbox/callback-dropbox.component';
import { OneDriveFoldersComponent } from './one-drive-folders/one-drive-folders.component';
import { DriveSearchComponent } from './drive-search/drive-search.component';
import {DropBox} from './dropbox/dropbox.service';
import {DropBoxFoldersComponent} from './dropbox-folders/dropbox-folders.component';
import { OneDrivePageComponent } from './onedrive-page/onedrive-page.component';
import { OnedriveListComponent } from './onedrive-list/onedrive-list.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { OneDriveAuthGuardService } from './onedrive/onedrive-auth-guard.service';
import { OneDriveMoveDialogComponent } from './onedrive-move-dialog/onedrive-move-dialog.component';
import { ViewerControllerComponent } from './viewer-controller/viewer-controller.component';
import { ViewerTopBarComponent } from './viewer-controller/viewer-top-bar/viewer-top-bar.component';
import { ViewerInfoPanelComponent } from './viewer-controller/viewer-info-panel/viewer-info-panel.component';
import { FileViewerComponent } from './viewer-controller/file-viewer/file-viewer.component';
import { MailViewerComponent } from './viewer-controller/file-viewer/mail-viewer/mail-viewer.component';
import { MetadataService } from './viewer-controller/viewer-info-panel/services/metadata.service';
import { OnedriveViewerComponent } from './onedrive-viewer/onedrive-viewer.component';
import { GoogledriveAuthGuardService } from "./google-drive/googledrive-auth-guard.service";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { DropboxPageComponent } from './dropbox-page/dropbox-page.component';
import { DropboxAuthGuardService } from './dropbox/dropbox-auth-guard.service';
import { DropboxListComponent } from './dropbox-list/dropbox-list.component';
import { DropboxViewerComponent } from './dropbox-viewer/dropbox-viewer.component';
import { CreateDropboxComponent } from './dropbox/create-dropbox.component';
import { GoogleDriveMoveDialogComponent } from './google-drive-move-dialog/google-drive-move-dialog.component';
import { DownloadMultipleTaskComponent } from './download-multiple-task/download-multiple-task.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        DmsRoutingModule,
        MatBottomSheetModule
    ],
    declarations: [
        DmsMenuComponent,
        DmsSearchBoxComponent,
        FilesComponent,
        DocListComponent,
        ShareListComponent,
        CreateFolderComponent,
        ConfirmDeleteComponent,
        CreateGoogleDriveComponent,
        WaitForImportComponent,
        CreateOneDriveComponent,
        CallbackComponent,
        ConfirmRestoreComponent,
        ConfirmPermanentDeleteComponent,
        DownloadFolderComponent,
        MoveDialogComponent,
        UploadFilesComponent,
        SharingComponent,
        ShareToEmailComponent,
        VersionHistoryComponent,
        RevertVersionComponent,
        DocTypeComponent,
        FoldersComponent,
        SearchComponent,
        ViewerComponent,
        ViewShareComponent,
        DeleteCommentComponent,
        TrashComponent,
        CorporateComponent,
        CorporateMemberComponent,
        SettingEtaxComponent,
        DocListComponent,
        TaxReportComponent,
        MonthlySummaryComponent,
        CorporatePermissionComponent,
        DownloadZipComponent,
        SharedWithMeComponent,
        SharedByMeComponent,
        SharedLinkComponent,
        AnnotationControllerComponent,
        DownloadListComponent,
        UploadProgressComponent,
        EtaxSharedComponent,
        InvoiceViewerComponent,
        PoweredByComponent,
        UploadProgressComponent,
        GoogleDrivePageComponent,
        GoogleDriveListComponent,
        GoogleDriveViewerComponent,
        ViewSharePublicComponent,
        ShareListComponent,
        ShareViewerComponent,
        ShareDownloadZipComponent,
        ShareDownloadFolderComponent,
        UploadProgressComponent,
        UploadNewVersionComponent,
        InsertMergeFilesComponent,
        GoogleDriveFoldersComponent,
        OneDriveFoldersComponent,
        DropBoxFoldersComponent,
        DriveSearchComponent,
        OneDrivePageComponent,
        OnedriveListComponent,
        BreadcrumbComponent,
        OneDriveMoveDialogComponent,
        ViewerControllerComponent,
        ViewerTopBarComponent,
        ViewerInfoPanelComponent,
        FileViewerComponent,
        MailViewerComponent,
        OnedriveViewerComponent,
        DropboxPageComponent,
        DropboxListComponent,
        DropboxViewerComponent,
        CreateDropboxComponent,
        CallbackDropboxComponent,
        GoogleDriveMoveDialogComponent,
        DownloadMultipleTaskComponent,
    ],
    exports: [
        DmsMenuComponent,
        DmsSearchBoxComponent,
        DocTypeComponent,
        FoldersComponent,
        AnnotationControllerComponent,
        GoogleDriveFoldersComponent,
        OneDriveFoldersComponent,
        DropBoxFoldersComponent,
        DriveSearchComponent,
        UploadProgressComponent,
    ],
    providers: [
        OneDrive,
        OneDriveAuthGuardService,
        DropBox,
        FileUploader,
        UploadService,
        AnnotationControllerComponent,
        AnnotationControllerService,
        MetadataService,
        GoogledriveAuthGuardService,
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DIALOG_DATA, useValue: {} },
        DropboxAuthGuardService,
    ]
})
export class DmsModule { }
